import moment from 'moment';

/**
 * English Swiss Locale
 * -> American English Words and Numbers
 * -> Swiss German Formatting
 */
const englishSwiss = moment.defineLocale('en-ch', {
  parentLocale: 'en',
});

moment.updateLocale('en-ch', {
  longDateFormat: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    L: 'DD.MM.YYYY',
    LL: 'D. MMMM YYYY',
    LLL: 'D. MMMM YYYY HH:mm',
    LLLL: 'dddd, D. MMMM YYYY HH:mm',
  },
});

export const customEnChConfig = englishSwiss;
